"use client";
import { usePopoverProviderContext } from "./popover-context.js";
import { createElement, createHook, forwardRef, useMergeRefs } from "@ariakit/react-utils";
//#region src/popover/popover-anchor.tsx
const TagName = "div";
/**
* Returns props to create a `PopoverAnchor` component.
* @see https://ariakit.com/components/popover
* @example
* ```jsx
* const store = usePopoverStore();
* const props = usePopoverAnchor({ store });
* <Role {...props}>Anchor</Role>
* <Popover store={store}>Popover</Popover>
* ```
*/
const usePopoverAnchor = createHook(function usePopoverAnchor({ store, ...props }) {
	const context = usePopoverProviderContext();
	store = store || context;
	props = {
		...props,
		ref: useMergeRefs(store?.setAnchorElement, props.ref)
	};
	return props;
});
/**
* Renders an element that acts as the anchor for the popover. The
* [`Popover`](https://ariakit.com/reference/popover) component will be
* positioned in relation to this element.
* @see https://ariakit.com/components/popover
* @example
* ```jsx {2}
* <PopoverProvider>
*   <PopoverAnchor>Anchor</PopoverAnchor>
*   <Popover>Popover</Popover>
* </PopoverProvider>
* ```
*/
const PopoverAnchor = forwardRef(function PopoverAnchor(props) {
	return createElement(TagName, usePopoverAnchor(props));
});
//#endregion
export { PopoverAnchor, usePopoverAnchor };

//# sourceMappingURL=popover-anchor.js.map